import React, { useRef, memo } from "react";
import classNames from "classnames";
import Modal from "react-modal";

import "./style.scss";

const Dialog = ({
  isOpen,
  onCloseDialog,
  className,
  overlayClass,
  renderBody,
  closeDisabled,
}) => {
  const el = useRef();

  const classes = classNames("Dialog", className);
  const overlayClasses = classNames("Dialog__overlay", overlayClass);

  return (
    <Modal
      className={classes}
      overlayClassName={overlayClasses}
      isOpen={isOpen}
      onRequestClose={onCloseDialog}
      ariaHideApp={false}
    >
      {!closeDisabled && (
        <div className="Dialog__close-dialog" onClick={onCloseDialog}></div>
      )}
      <div className="Dialog__body" ref={el}>
        {renderBody()}
      </div>
    </Modal>
  );
};
export default memo(Dialog);
